var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 43,
    viewBox: "0 0 51 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 4.167C51 1.95786 49.2091 0.166992 47 0.166992H0.333332V42.8337H47C49.2091 42.8337 51 41.0428 51 38.8337V4.167Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4583 28.667V14.0649L32.1167 18.7232L34.625 16.1253L25.6667 7.16699L16.7083 16.1253L19.2167 18.7232L23.875 14.0649V28.667H27.4583ZM36.4167 35.8337C37.4021 35.8337 38.2454 35.4831 38.9465 34.782C39.6476 34.0808 39.9988 33.2369 40 32.2503V26.8753H36.4167V32.2503H14.9167V26.8753H11.3333V32.2503C11.3333 33.2357 11.6839 34.0796 12.385 34.782C13.0862 35.4843 13.9301 35.8349 14.9167 35.8337H36.4167Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.be301d5df6056aebbd349bf8cf3e88db.svg";
export { ForwardRef as ReactComponent };